import React from "react";
import { Modal,Spinner } from "react-bootstrap";
import {Form, Container} from "react-bootstrap";
import ColDynamic from "../EntryForms/WrapperComponents/ColDynamic";
import "../../containers/ControlMeasures/ControlMeasures.css";
import DatePicker from "../UI/DatePicker/DatePicker";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import InputComponent from "../UI/InputComponent/InputComponent";
import Upload from "../UI/Upload/Upload";
import UploadComponent from "../UI/Upload/UploadComponent";
import Dropdown from "../UI/Dropdown/Dropdown";
import ModalComponent from "../UI/Modal/Modal";
import moment from "moment";

const unosPrekrsajnogPostupka = (props) => {
 

  return (
    <>
      <ModalComponent
        size="l"
        show={props.modalPP}
        onHide={props.hideModalPP}
        className="heder"
        centered
        title="Unos prekršajnog postupka"
      >
        <Modal.Body>
          <div className="justify-content-center" key={"form"}>
            <div className="align-self-center modal-mjere">
              <Form onSubmit={props.submitHandlerPP}>
               <div>
          
                <label>Prekršajni postupak</label>
            
                 <div  className="unos_upload">
                  <UploadComponent
                   
                    key={"testPP"}
                    id={"testIdPP"}
                    onChange={props.uploadHandlerPP}
                    fileList={props.formDataPP.selectedFile}
                    style={
                      props.error &&
                      props.formDataPP.selectedFile.length < 1 &&
                      "red"
                    }
                  />
                </div>

                <InputComponent
                  id="note"
                  value={props.formDataPP.note}
                  onChange={props.userInputFormHandlerPP}
                  controlLabel={"Prekršajni postupak - napomena"}
                  className="input-modal"
                  name="napomena"
                />
                </div>

                <div className="row" key={"button"}>
                  <div className="col-md-6">
                    <ButtonComponent
                      type="submit"
                      block={true}
                      variant="primary"
                      //  onClick={this.hideModal}
                      disabled={props.loaderPP}
                    >
                      {props.loaderPP ? 
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      /> 
                      :
                      (<p>Spremi</p>)}
                    </ButtonComponent>
                  </div>
                  <div className="col-md-6">
                    <ButtonComponent
                      onClick={props.hideModalPP}
                      block={true}
                      variant="danger"
                    >
                      Odustani
                    </ButtonComponent>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </Modal.Body>
      </ModalComponent>
    </>
  );
};

export default unosPrekrsajnogPostupka;